export class weightageUserReportModel {
  GetWeightageUserReportAPI: string;
  GetAllBUHeadListAPI: string;
  DepartmentsListByBUHeadAPI: string;
  UsersListByBUHeadAndDepartmentListAPI: string;


}
